import { render, staticRenderFns } from "./addgameMg.vue?vue&type=template&id=ea55c8a6&"
import script from "./addgameMg.vue?vue&type=script&lang=js&"
export * from "./addgameMg.vue?vue&type=script&lang=js&"
import style0 from "./addgameMg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea55c8a6')) {
      api.createRecord('ea55c8a6', component.options)
    } else {
      api.reload('ea55c8a6', component.options)
    }
    module.hot.accept("./addgameMg.vue?vue&type=template&id=ea55c8a6&", function () {
      api.rerender('ea55c8a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/configuration/components/addgameMg.vue"
export default component.exports